import React, { Component } from "react";
import LayoutWrapper from "../LayoutWrapper";
import { Switch, DatePicker, Select, Input } from "antd";
import AppTable from "../../../partials/AppTable";
import "./dashboard.scss";
import schoolmanagementapi from "../../../../api/devapis/schoolmanagementapi";
import issuecategoryapi from "../../../../api/devapis/issuecategoryapi";

const { RangePicker } = DatePicker;

export class Dashboard extends Component {
  constructor(props) {
    super(props);
    this.state = {
      onlySlaBreached: false,
      dateRange: null,
      selectedSchools: [],
      tableTab: "school", // 'school' or 'category'
      showAgeingFilters: false,
      kpiData: null,
      schoolData: [],
      categoryData: [],
      severityData: [],
      ageingData: [],
      allSchools: [],
      allCategories: [],
      allPriorities: [],
      ageingFilterSchools: [],
      ageingFilterSeverities: [],
      ageingFilterStatuses: [],
      ageingFilterDaysStart: "",
      ageingFilterDaysEnd: "",
    };
  }

  componentDidMount() {
    const role = localStorage.getItem("currentAdminRole") || window.store?.getState()?.root?.user?.role;
    if (role === "SCHOOL_COORDINATOR") {
      window.navigate("/schoolinframaintenancetracker");
      return;
    }
    this.fetchDashboardData();
  }

  fetchDashboardData = () => {
    this.fetchIssueKpis();
    this.fetchDataBySchool();
    this.fetchDataByCategory();
    this.fetchDataByPriority();
    this.fetchDataByDays();
    this.fetchDropdownLists();
  };

  fetchDropdownLists = () => {
    // Categories
    const apiGetIssueCategories = this.props.api?.apiGetIssueCategories || window.app?.props?.api?.apiGetIssueCategories;
    if (apiGetIssueCategories) {
      apiGetIssueCategories()
        .then(res => {
          let raw = res.data || res || [];
          if (!Array.isArray(raw)) {
            if (raw.data && Array.isArray(raw.data)) raw = raw.data;
            else if (raw.records && Array.isArray(raw.records)) raw = raw.records;
            else raw = [raw];
          }
          const catOptions = raw.filter(c => c && (c.name || c.category_name)).map(c => ({
            value: c.issueCategoryId || c._id || c.id || c.name || c.category_name,
            label: c.name || c.category_name
          }));
          this.setState({ allCategories: catOptions });
        }).catch(e => console.error(e));
    }

    // Schools
    let role = localStorage.getItem("currentAdminRole");
    const apiGetSchools = (role === "SUPER_ADMIN" || role === "OPERATION_TEAM") 
      ? (this.props.api?.apiGetAllSchoolLists || window.app?.props?.api?.apiGetAllSchoolLists)
      : (this.props.api?.apiGetAllSchoolList || window.app?.props?.api?.apiGetAllSchoolList);

    if (apiGetSchools) {
      apiGetSchools()
        .then(res => {
          let raw = res.data || res || [];
          if (!Array.isArray(raw)) {
            if (raw.data && Array.isArray(raw.data)) raw = raw.data;
            else if (raw.records && Array.isArray(raw.records)) raw = raw.records;
            else raw = [raw];
          }

          let schoolOptions = [];
          if (raw.length > 0 && Array.isArray(raw[0].records)) {
            schoolOptions = raw[0].records.filter(s => s && (s.school_name || s.name)).map(s => ({
              value: s.school_id || s._id || s.school_name || s.name,
              label: s.school_name || s.name
            }));
          } else {
            schoolOptions = raw.filter(s => s && (s.school_name || s.name)).map(s => ({
              value: s.school_id || s._id || s.school_name || s.name,
              label: s.school_name || s.name
            }));
          }

          this.setState({ allSchools: schoolOptions });
        }).catch(e => console.error(e));
    }

    // Priorities
    const apiGetIssuePriorities = this.props.api?.apiGetIssuePriorities || window.app?.props?.api?.apiGetIssuePriorities;
    if (apiGetIssuePriorities) {
      apiGetIssuePriorities()
        .then(res => {
          let raw = res.data || res || [];
          if (!Array.isArray(raw)) {
            if (raw.data && Array.isArray(raw.data)) raw = raw.data;
            else if (raw.records && Array.isArray(raw.records)) raw = raw.records;
            else raw = [raw];
          }
          const priorityOptions = raw.map(p => ({
            value: p.issuePriorityId || p._id || p.id || p.name,
            label: p.name || p.priorityName || p._id
          }));
          this.setState({ allPriorities: priorityOptions });
        }).catch(e => console.error(e));
    }
  };

  getAuthHeaders = () => {
    let token =
      window.store?.getState()?.root?.auth ||
      localStorage.getItem('token') ||
      localStorage.getItem('auth') ||
      '';
    if (token) {
      token = token.trim();
      if (!token.toLowerCase().startsWith('bearer ')) {
        token = `Bearer ${token}`;
      }
    }
    return {
      ...(token ? { Authorization: token } : {}),
      "Content-Type": "application/json",
    };
  };

  getBaseUrl = () => {
    return window.envconfig?.[window.environment]?.api_base ||
      window.axios?.defaults?.baseURL ||
      "https://devapi.cognospace.in";
  };

  fetchDataBySchool = () => {
    let payload = {};
    if (this.state.dateRange && this.state.dateRange.length === 2) {
      if (this.state.dateRange[0]) payload.raisedOnStartDate = this.state.dateRange[0].format('YYYY-MM-DD');
      if (this.state.dateRange[1]) payload.raisedOnEndDate = this.state.dateRange[1].format('YYYY-MM-DD');
    }
    if (this.state.tableTab === "school" && this.state.selectedSchools && this.state.selectedSchools.length > 0) {
      payload.schoolId = this.state.selectedSchools.join(',');
    }

    const apiCall = this.props.api?.apiGetIssueBySchool || window.app?.props?.api?.apiGetIssueBySchool;
    if (!apiCall) return;

    apiCall(payload)
      .then(res => {
        let rawData = res.data || res || [];
        if (!Array.isArray(rawData)) rawData = [rawData];
        const parsed = rawData.map(item => {
          let open = item.openCount || 0;
          let inprogress = item.inProgressCount || 0;
          let resolved = (item.resolvedCount || 0) + (item.closedCount || 0);

          let name = "Unknown";
          if (item.schoolData?.school_name) name = item.schoolData.school_name;
          else if (item.schoolData?.name) name = item.schoolData.name;
          else if (item._id?.schoolId) name = item._id.schoolId;

          return {
            name,
            schoolId: item.schoolData?.school_id || item.schoolData?._id || item._id?.schoolId || name,
            open, inprogress, resolved,
            total: item.totalCount || (open + inprogress + resolved + (item.onholdCount || 0) + (item.cancelledCount || 0))
          };
        });
        this.setState({ schoolData: parsed });
      })
      .catch(e => console.error(e));
  };

  fetchDataByCategory = () => {
    let payload = {};
    if (this.state.dateRange && this.state.dateRange.length === 2) {
      if (this.state.dateRange[0]) payload.raisedOnStartDate = this.state.dateRange[0].format('YYYY-MM-DD');
      if (this.state.dateRange[1]) payload.raisedOnEndDate = this.state.dateRange[1].format('YYYY-MM-DD');
    }
    if (this.state.tableTab === "category" && this.state.selectedSchools && this.state.selectedSchools.length > 0) {
      payload.issueCategory = this.state.selectedSchools.join(',');
    }

    const apiCall = this.props.api?.apiGetIssueByCategory || window.app?.props?.api?.apiGetIssueByCategory;
    if (!apiCall) return;

    apiCall(payload)
      .then(res => {
        let rawData = res.data || res || [];
        if (!Array.isArray(rawData)) rawData = [rawData];
        const parsed = rawData.map(item => {
          let open = item.openCount || 0;
          let inprogress = item.inProgressCount || 0;
          let resolved = (item.resolvedCount || 0) + (item.closedCount || 0);

          let name = "Unknown";
          if (item._id?.categoryName) name = item._id.categoryName;
          else if (item.categoryData?.name) name = item.categoryData.name;
          else if (typeof item._id === "string") name = item._id;

          return {
            name,
            categoryId: item.categoryData?._id || item._id?.categoryId || name,
            open, inprogress, resolved,
            total: item.totalCount || (open + inprogress + resolved + (item.onholdCount || 0) + (item.cancelledCount || 0))
          };
        });
        this.setState({ categoryData: parsed });
      })
      .catch(e => console.error(e));
  };

  fetchDataByPriority = () => {
    let payload = {};
    if (this.state.dateRange && this.state.dateRange.length === 2) {
      if (this.state.dateRange[0]) payload.raisedOnStartDate = this.state.dateRange[0].format('YYYY-MM-DD');
      if (this.state.dateRange[1]) payload.raisedOnEndDate = this.state.dateRange[1].format('YYYY-MM-DD');
    }

    const apiCall = this.props.api?.apiGetIssueByPriority || window.app?.props?.api?.apiGetIssueByPriority;
    if (!apiCall) return;

    apiCall(payload)
      .then(res => {
        let rawData = res.data || res || [];
        if (!Array.isArray(rawData)) rawData = [rawData];
        let totalCount = 0;
        const parsed = rawData.map(item => {
          const label = item.name || item.priorityName || item.issuePriorityData?.name || item._id?.priorityName || item._id || "None";
          const count = item.count || item.totalCount || item.total || 0;
          totalCount += count;
          const lblLower = String(label).toLowerCase();
          return {
            label, count,
            color: (lblLower.includes('critical') || lblLower.includes('p0')) ? '#c62828' :
              (lblLower.includes('high') || lblLower.includes('p1')) ? '#ef6c00' :
                (lblLower.includes('medium') || lblLower.includes('p2')) ? '#f9a825' : '#2e7d32',
            cls: (lblLower.includes('critical') || lblLower.includes('p0')) ? 'severity-critical' :
              (lblLower.includes('high') || lblLower.includes('p1')) ? 'severity-high' :
                (lblLower.includes('medium') || lblLower.includes('p2')) ? 'severity-medium' : 'severity-low'
          };
        });
        parsed.forEach(p => p.percent = totalCount ? Math.round((p.count / totalCount) * 100) : 0);
        this.setState({ severityData: parsed });
      })
      .catch(e => console.error(e));
  };

  fetchDataByDays = () => {
    let role = localStorage.getItem("currentAdminRole");
    const apiGetSchools = (role === "SUPER_ADMIN" || role === "OPERATION_TEAM") 
      ? (this.props.api?.apiGetAllSchoolLists || window.app?.props?.api?.apiGetAllSchoolLists)
      : (this.props.api?.apiGetAllSchoolList || window.app?.props?.api?.apiGetAllSchoolList);

    const apiGetIssueByDays = this.props.api?.apiGetIssueByDays || window.app?.props?.api?.apiGetIssueByDays;
    if (!apiGetIssueByDays || !apiGetSchools) return;

    let payload = {};
    if (this.state.dateRange && this.state.dateRange.length === 2) {
      if (this.state.dateRange[0]) payload.raisedOnStartDate = this.state.dateRange[0].format('YYYY-MM-DD');
      if (this.state.dateRange[1]) payload.raisedOnEndDate = this.state.dateRange[1].format('YYYY-MM-DD');
    }
    if (this.state.ageingFilterSchools && this.state.ageingFilterSchools.length > 0) {
      payload.schoolId = this.state.ageingFilterSchools.join(',');
    }
    if (this.state.ageingFilterSeverities && this.state.ageingFilterSeverities.length > 0) {
      payload.issuePriorityId = this.state.ageingFilterSeverities.join(',');
    }
    if (this.state.ageingFilterStatuses && this.state.ageingFilterStatuses.length > 0) {
      payload.status = this.state.ageingFilterStatuses.join(',');
    }
    if (this.state.ageingFilterDaysStart) {
      payload.daysOpenStart = this.state.ageingFilterDaysStart;
    }
    if (this.state.ageingFilterDaysEnd) {
      payload.daysOpenEnd = this.state.ageingFilterDaysEnd;
    }
    if (this.state.onlySlaBreached !== undefined) {
      payload.showOnlySLABreached = this.state.onlySlaBreached;
    }

    Promise.all([
      apiGetIssueByDays(payload),
      apiGetSchools().catch(() => ({}))
    ])
      .then(([daysRes, schoolsRes]) => {
        let rawSchools = schoolsRes.data || schoolsRes || [];
        if (!Array.isArray(rawSchools)) {
          if (rawSchools.data && Array.isArray(rawSchools.data)) rawSchools = rawSchools.data;
          else if (rawSchools.records && Array.isArray(rawSchools.records)) rawSchools = rawSchools.records;
          else rawSchools = [rawSchools];
        }
        let schoolList = [];
        if (rawSchools.length > 0 && Array.isArray(rawSchools[0].records)) {
          schoolList = rawSchools[0].records;
        } else {
          schoolList = rawSchools;
        }
        const schoolMap = {};
        schoolList.forEach(s => {
          if (s && (s.school_id || s._id)) {
            schoolMap[s.school_id || s._id] = s.school_name || s.name;
          }
        });

        let rawData = daysRes.data || daysRes || [];
        if (!Array.isArray(rawData)) {
          if (rawData.records && Array.isArray(rawData.records)) rawData = rawData.records;
          else rawData = [rawData];
        }
        const parsed = rawData.map((item, idx) => {
          const val = item.openDays !== undefined ? item.openDays : (item.ageing !== undefined ? item.ageing : (item.daysOpen || 0));
          const daysStr = (val !== undefined && val !== null && val !== "-") ? `${val} day${val === 1 || val === 0 ? '' : 's'}` : "-";

          let schoolId = item.schoolId || item.school;
          let schoolName = item.schoolData?.school_name || item.schoolData?.name || item.schoolName || schoolMap[schoolId] || schoolId || "-";
          if (typeof schoolName === 'object') schoolName = schoolName.name || "-";

          let priority = item.issuePriorityData?.name || item.priorityName || item.priority || "-";
          let status = item.status || item.statusData?.name || item.statusName || "-";

          let statusDisplay = String(status).toUpperCase();
          if (statusDisplay === "OPEN") statusDisplay = "Open";
          else if (statusDisplay.includes("PROGRESS")) statusDisplay = "In Progress";
          else if (statusDisplay.includes("HOLD")) statusDisplay = "On Hold";
          else if (statusDisplay.includes("RESOLV")) statusDisplay = "Resolved";
          else if (statusDisplay.includes("CLOSE")) statusDisplay = "Closed";
          else if (statusDisplay.includes("CANCEL")) statusDisplay = "Cancelled";

          return {
            id: String(idx + 1),
            school: schoolName,
            schoolId: schoolId,
            priority: priority,
            priorityId: item.issuePriorityId || item.priorityId || item.priority,
            status: statusDisplay,
            days: daysStr,
            sla: item.slaBreached || item.isSlaBreached || false
          };
        });
        this.setState({ ageingData: parsed });
      })
      .catch(e => console.error(e));
  };

  fetchIssueKpis = () => {
    let payload = {};
    if (this.state.dateRange && this.state.dateRange.length === 2) {
      if (this.state.dateRange[0]) payload.raisedOnStartDate = this.state.dateRange[0].format('YYYY-MM-DD');
      if (this.state.dateRange[1]) payload.raisedOnEndDate = this.state.dateRange[1].format('YYYY-MM-DD');
    }

    const apiCall = this.props.api?.apiGetIssueKpis || window.app?.props?.api?.apiGetIssueKpis;
    if (!apiCall) return;

    apiCall(payload)
      .then(res => {
        if (res && res.data && res.data[0]) {
          this.setState({ kpiData: res.data[0] });
        }
      })
      .catch(err => console.error("Failed to fetch KPIs:", err));
  };

  getSchoolColumns() {
    return [
      { dataIndex: "name", title: this.state.tableTab === "school" ? "SCHOOL" : "CATEGORY", sorter: false },
      { dataIndex: "open", title: "OPEN", sorter: false },
      { dataIndex: "inprogress", title: "IN PROGRESS", sorter: false },
      { dataIndex: "resolved", title: "RESOLVED", sorter: false },
      { dataIndex: "total", title: <div className="text-center">TOTAL</div>, sorter: false },
    ];
  }

  getAgeingColumns() {
    return [
      { dataIndex: "id", title: "Issue #", sorter: false },
      { dataIndex: "school", title: "School", sorter: false },
      {
        dataIndex: "priority",
        title: "Priority",
        sorter: false,
        render: (text) => (
          <span className={`badge-priority priority-${(text || "").toLowerCase()}`}>{text}</span>
        )
      },
      {
        dataIndex: "status",
        title: "Status",
        sorter: false,
        render: (text, record) => {
          const statusKey = (text || "").toLowerCase().replace(/\s/g, "");
          return (
            <div className="d-inline-flex align-items-center gap-2">
              <span className={`badge-pill status-${statusKey}`}>{text}</span>
              {record.sla && (
                <span className="sla-alert">
                  <i className="la la-exclamation-triangle"></i> SLA
                </span>
              )}
            </div>
          );
        }
      },
      {
        dataIndex: "days",
        title: <div className="text-center">Days Open</div>,
        sorter: false
      }
    ];
  }

  renderCards() {
    const { kpiData } = this.state;

    let openCount = 0;
    let inProgressCount = 0;
    let resolvedClosedCount = 0;
    let slaBreachedCount = 0;

    if (kpiData) {
      slaBreachedCount = kpiData.slaBreachedCount || (kpiData.slaBreachedPipeline && kpiData.slaBreachedPipeline[0]?.slaBreached) || 0;

      if (kpiData.statusData && Array.isArray(kpiData.statusData)) {
        kpiData.statusData.forEach(item => {
          const status = String(item._id || "").toUpperCase().replace(/[\s-_]/g, '');
          const count = item.count || 0;
          if (status === 'OPEN') openCount += count;
          else if (status.includes('PROGRESS')) inProgressCount += count;
          else if (status.includes('RESOLV') || status.includes('CLOSE')) resolvedClosedCount += count;
        });
      }
    }

    const formatCount = (num) => String(num).padStart(2, '0');

    const cards = [
      { count: formatCount(openCount), label: "Open" },
      { count: formatCount(inProgressCount), label: "In Progress" },
      { count: formatCount(resolvedClosedCount), label: "Resolved/ closed" },
      { count: formatCount(slaBreachedCount), label: "Breaching Response Window" }
    ];

    return (
      <div className="row g-3 mb-4">
        {cards.map((card, i) => (
          <div className="col-12 col-sm-6 col-md-3" key={i}>
            <div className="orange-card">
              <div className="icon-wrapper">
                <i className="la la-graduation-cap"></i>
              </div>
              <div className="info-wrapper">
                <h3>{card.count}</h3>
                <p>{card.label}</p>
              </div>
            </div>
          </div>
        ))}
      </div>
    );
  }

  renderSeverity() {
    const severities = this.state.severityData && this.state.severityData.length > 0 ? this.state.severityData : [];

    return (
      <div className="severity-card">
        <h5>Open issues by severity</h5>
        {severities.length === 0 ? (
          <div className="text-muted p-3">No severity data available</div>
        ) : severities.map((item, i) => (
          <div className="severity-row" key={i}>
            <div className={`severity-label ${item.cls}`}>{item.label}</div>
            <div className="severity-progress-wrap">
              <div className="severity-progress" style={{ width: `${item.percent}%`, backgroundColor: item.color }}></div>
            </div>
            <div className="severity-count">{item.count}</div>
          </div>
        ))}
      </div>
    );
  }

  renderSchoolTable() {
    let data = this.state.tableTab === "school" ? this.state.schoolData : this.state.categoryData;

    return (
      <div className="table-card">
        <div className="table-header">
          <div className="btn-group" role="group">
            <button
              type="button"
              className={`btn btn-sm ${this.state.tableTab === "school" ? "btn-light border fw-bold active text-primary" : "btn-light border text-muted"}`}
              onClick={() => this.setState({ tableTab: "school", selectedSchools: [] }, () => this.fetchDataBySchool())}
            >
              By school
            </button>
            <button
              type="button"
              className={`btn btn-sm ${this.state.tableTab === "category" ? "btn-light border fw-bold active text-primary" : "btn-light border text-muted"}`}
              onClick={() => this.setState({ tableTab: "category", selectedSchools: [] }, () => this.fetchDataByCategory())}
            >
              By category
            </button>
          </div>
          <div>
            <Select
              mode="multiple"
              placeholder={this.state.tableTab === "school" ? "School Name (multiselect)" : "Category Name (multiselect)"}
              style={{ minWidth: 260 }}
              options={
                this.state.tableTab === "school"
                  ? (this.state.allSchools.length > 0 ? this.state.allSchools : this.state.schoolData.map(s => ({ value: s.schoolId || s.name, label: s.name })))
                  : (this.state.allCategories.length > 0 ? this.state.allCategories : this.state.categoryData.map(c => ({ value: c.categoryId || c.name, label: c.name })))
              }
              value={this.state.selectedSchools}
              onChange={(val) => this.setState({ selectedSchools: val }, () => {
                if (this.state.tableTab === "school") this.fetchDataBySchool();
                else this.fetchDataByCategory();
              })}
              allowClear
            />
          </div>
        </div>
        <div className="table-responsive">
          <AppTable
            data={data}
            columns={this.getSchoolColumns()}
            editable={false}
            deletable={false}
            viewable={false}
            reorder={true}
          />
        </div>
      </div>
    );
  }

  renderAgeingTable() {
    let data = this.state.ageingData && this.state.ageingData.length > 0 ? this.state.ageingData : [];

    const ISSUE_STATUS = {
      OPEN: 'OPEN',
      INPROGRESS: 'INPROGRESS',
      CANCELLED: 'CANCELLED',
      RESOLVED: 'RESOLVED',
      ONHOLD: 'ONHOLD',
      CLOSED: 'CLOSED',
    };

    const uniqueStatuses = Object.keys(ISSUE_STATUS).map(k => ({
      value: ISSUE_STATUS[k],
      label: k === 'INPROGRESS' ? 'In Progress' : k === 'ONHOLD' ? 'On Hold' : k.charAt(0) + k.slice(1).toLowerCase()
    }));
    const uniqueSchoolsMap = {};
    (this.state.ageingData || []).forEach(d => {
      if (d.school && d.school !== "-") uniqueSchoolsMap[d.schoolId || d.school] = d.school;
    });
    const uniqueSchools = Object.keys(uniqueSchoolsMap).map(k => ({ value: k, label: uniqueSchoolsMap[k] }));

    const uniquePrioritiesMap = {};
    (this.state.ageingData || []).forEach(d => {
      if (d.priority && d.priority !== "-") uniquePrioritiesMap[d.priorityId || d.priority] = d.priority;
    });
    const uniquePriorities = Object.keys(uniquePrioritiesMap).map(k => ({ value: k, label: uniquePrioritiesMap[k] }));

    return (
      <div className="table-card">
        <div className="table-header">
          <h5 className="table-title">Ageing — open issues outstanding longest</h5>
          <div className="d-flex align-items-center gap-3">
            <button
              className="btn btn-link text-dark text-decoration-none fw-bold p-0"
              style={{ fontSize: "14px" }}
              onClick={() => this.setState({ showAgeingFilters: !this.state.showAgeingFilters })}
            >
              <i className="la la-filter me-1"></i> Filters <i className={`la la-angle-${this.state.showAgeingFilters ? "up" : "down"} ms-1`}></i>
            </button>
            <button
              className="btn btn-link text-danger text-decoration-none fw-bold p-0"
              style={{ fontSize: "14px" }}
              onClick={() => this.setState({ ageingFilterSchools: [], ageingFilterSeverities: [], ageingFilterStatuses: [], ageingFilterDaysStart: "", ageingFilterDaysEnd: "" }, () => this.fetchDataByDays())}
            >
              Clear Filter
            </button>
          </div>
        </div>
        {this.state.showAgeingFilters && (
          <div className="p-3 bg-light border-bottom">
            <div className="row g-3">
              <div className="col-md-3">
                <Select
                  mode="multiple"
                  placeholder="School name (Multiselect)"
                  style={{ width: "100%" }}
                  options={this.state.allSchools.length > 0 ? this.state.allSchools : uniqueSchools}
                  value={this.state.ageingFilterSchools}
                  onChange={val => this.setState({ ageingFilterSchools: val }, () => this.fetchDataByDays())}
                  allowClear
                />
              </div>
              <div className="col-md-3">
                <Select
                  mode="multiple"
                  placeholder="Severity (Multiselect)"
                  style={{ width: "100%" }}
                  options={this.state.allPriorities && this.state.allPriorities.length > 0 ? this.state.allPriorities : uniquePriorities}
                  value={this.state.ageingFilterSeverities}
                  onChange={val => this.setState({ ageingFilterSeverities: val }, () => this.fetchDataByDays())}
                  allowClear
                />
              </div>
              <div className="col-md-3">
                <Select
                  mode="multiple"
                  placeholder="Status (Multiselect)"
                  style={{ width: "100%" }}
                  options={uniqueStatuses}
                  value={this.state.ageingFilterStatuses}
                  onChange={val => this.setState({ ageingFilterStatuses: val }, () => this.fetchDataByDays())}
                  allowClear
                />
              </div>
              <div className="col-md-3">
                <div className="d-flex align-items-center gap-2">
                  <Input
                    type="number"
                    placeholder="Days Open (Start)"
                    value={this.state.ageingFilterDaysStart}
                    onChange={e => this.setState({ ageingFilterDaysStart: e.target.value })}
                    onBlur={() => this.fetchDataByDays()}
                    onPressEnter={() => this.fetchDataByDays()}
                  />
                  <span className="fw-bold">-</span>
                  <Input
                    type="number"
                    placeholder="Days Open (End)"
                    value={this.state.ageingFilterDaysEnd}
                    onChange={e => this.setState({ ageingFilterDaysEnd: e.target.value })}
                    onBlur={() => this.fetchDataByDays()}
                    onPressEnter={() => this.fetchDataByDays()}
                  />
                </div>
              </div>
            </div>
          </div>
        )}
        <div className="table-responsive">
          <AppTable
            data={data}
            columns={this.getAgeingColumns()}
            editable={false}
            deletable={false}
            viewable={false}
            reorder={true}
          />
        </div>
      </div>
    );
  }

  render() {
    const headerRight = (
      <div className="d-flex align-items-center gap-4">
        <div className="d-flex align-items-center gap-2">
          <Switch
            checked={this.state.onlySlaBreached}
            onChange={(val) => this.setState({ onlySlaBreached: val }, () => {
              this.fetchDashboardData();
            })}
            style={{ backgroundColor: this.state.onlySlaBreached ? "#fca000" : undefined }}
          />
          <span className="fw-bold text-dark" style={{ fontSize: "14px" }}>
            Show Only SLA Breached Issues
          </span>
        </div>
        <RangePicker
          placeholder={["Raised On (Date Range)", ""]}
          style={{ width: 260 }}
          value={this.state.dateRange}
          onChange={(val) => this.setState({ dateRange: val }, () => {
            this.fetchDashboardData();
          })}
        />
      </div>
    );

    return (
      <LayoutWrapper title="Dashboard & Reporting" headerRight={headerRight}>
        <div className="dashboard-reporting mt-4">
          {this.renderCards()}
          {this.renderSeverity()}
          {this.renderSchoolTable()}
          {this.renderAgeingTable()}
        </div>
      </LayoutWrapper>
    );
  }
}

export default Dashboard;
